export default __webpack_public_path__ + "22423907aee839e6e448edb0b54c395e.svg";